import {
  decodeEngineArchive,
  encodeEngineArchive,
} from "../document/engine-format";
import type { ZipProvider } from "../adapters/jszip-project";
import type { EngineDocument } from "../scene/model";
import { assertNativeDocument } from "./document";
import { decodeLegacyProject } from "../document/legacy-3dcd";
import type { ProjectDocumentV2 } from "../document/model";
import { isRecord } from "../document/model";
export async function saveNativeArchive(
  document: EngineDocument,
  Zip: ZipProvider,
) {
  assertNativeDocument(document);
  const entries = encodeEngineArchive(document, new Date().toISOString());
  const zip = new Zip();
  zip.file("manifest.json", entries.manifest);
  zip.file("document.json", entries.document);
  for (const r of entries.resources) zip.file(r.path, r.bytes);
  return zip.generateAsync({
    type: "blob",
    compression: "DEFLATE",
    compressionOptions: { level: 6 },
  });
}
export async function openNativeArchive(
  file: File,
  Zip: ZipProvider,
  importLegacy?: (project: ProjectDocumentV2) => Promise<EngineDocument>,
) {
  if (!/\.(cepro|3dcd)$/i.test(file.name))
    throw new Error("Выберите проект .3dcd или .cepro.");
  const zip = await Zip.loadAsync(await file.arrayBuffer());
  const manifest = zip.file("manifest.json");
  if (!manifest) throw new Error("В архиве отсутствует описание проекта.");
  const manifestText = await manifest.async("string");
  const metadata: unknown = JSON.parse(manifestText);
  // Extension is the public filename; the manifest distinguishes old and new schemas.
  if (!isRecord(metadata) || metadata.format !== "creator-engine-pro") {
    const project = zip.file("project.json");
    if (!project || !importLegacy)
      throw new Error("В архиве отсутствует проект .3dcd.");
    return importLegacy(
      decodeLegacyProject({
        manifest: manifestText,
        project: await project.async("string"),
      }),
    );
  }
  const document = zip.file("document.json");
  if (!document)
    throw new Error("В архиве отсутствует документ Creator Engine Pro.");
  const scene = await decodeEngineArchive(
    manifestText,
    await document.async("string"),
    async (path) => {
      const resource = zip.file(path);
      if (!resource) throw new Error("В проекте отсутствует изображение.");
      return resource.async("base64");
    },
  );
  assertNativeDocument(scene);
  return scene;
}
